<pdq-dropdown
  *ngIf="!selectValue?.data"
  mode="tight-ghost"
  [border]="false"
  buttonFontSize="16"
  class="select-option"
  (onChange)="setOption({ property: 'data', value: $event })"
  [options]="options"
  [optionsFormatter]="formatter"
  [placeholder]="placeholder">
</pdq-dropdown>
<span class="wrapper" *ngIf="selectValue?.data" [ngSwitch]="selectValue?.data?.value">
  <span *ngSwitchCase="'forDays'" class="row">
    <span>{{ text }} <span class="conjunctions" *ngIf="displayConjunctions">for</span></span>
    <pdq-input-arrows
      class="action-input"
      [value]="selectValue?.x || undefined"
      (onKeyup)="setOption({ property: 'x', value: $event })"
      [min]="0"
      [max]="60"></pdq-input-arrows>
    <pdq-dropdown
      *ngIf="dayTypeOptions?.length; else daysText"
      mode="tight-ghost"
      [border]="false"
      buttonFontSize="16"
      class="action-dropdown"
      [options]="dayTypeOptions"
      [defaultOption]="selectValue?.dayType || dayTypeOptions[0]"
      (onChange)="setOption({ property: 'dayType', value: $event })"></pdq-dropdown>
    <ng-template #daysText> <span>days</span></ng-template>
  </span>
  <span *ngSwitchCase="'daysBefore'" class="row">
    <span>{{ text }} <span class="conjunctions" *ngIf="displayConjunctions">until</span></span>
    <pdq-input-arrows
      class="action-input"
      [value]="selectValue?.x || undefined"
      (onKeyup)="setOption({ property: 'x', value: $event })"
      [min]="0"
      [max]="30"></pdq-input-arrows>
    <pdq-dropdown
      *ngIf="dayTypeOptions?.length; else daysText"
      mode="tight-ghost"
      [border]="false"
      buttonFontSize="16"
      class="action-dropdown"
      [options]="dayTypeOptions"
      [defaultOption]="selectValue?.dayType || dayTypeOptions[0]"
      (onChange)="setOption({ property: 'dayType', value: $event })"></pdq-dropdown>
    <ng-template #daysText> <span>days</span></ng-template>
    <span> before</span>
    <pdq-dropdown
      mode="tight-ghost"
      [border]="false"
      buttonFontSize="16"
      class="action-dropdown"
      [defaultOption]="selectValue?.before || (deliveryDateOptions?.length && deliveryDateOptions[0])"
      [options]="deliveryDateOptions"
      (onChange)="setOption({ property: 'before', value: $event })">
    </pdq-dropdown>
  </span>
  <span *ngSwitchCase="'dayEveryMonth'" class="row">
    <span>{{ text }} <span class="conjunctions" *ngIf="displayConjunctions">until</span></span>
    <pdq-input-arrows
      class="action-input"
      [value]="selectValue?.x || undefined"
      (onKeyup)="setOption({ property: 'x', value: $event })"
      [min]="1"
      [max]="31"></pdq-input-arrows>
    <span>day of every month</span>
  </span>
  <span *ngSwitchCase="'productMetafieldsDays'" class="row">
    <span>
      <pdq-input
        type="text"
        placeholder="Product metafield key"
        [value]="selectValue?.productMetafieldKey || undefined"
        (onKeyup)="setOption({ property: 'productMetafieldKey', value: $event })"></pdq-input>
    </span>
    <span> days, add</span>
    <span>
      <pdq-input-arrows
        class="action-input"
        [value]="selectValue?.x || undefined"
        (onKeyup)="setOption({ property: 'x', value: $event })"
        [min]="0"
        [max]="60"></pdq-input-arrows>
    </span>
    <span>additional</span>
    <span>
      <pdq-dropdown
        *ngIf="dayTypeOptions?.length; else daysText"
        mode="tight-ghost"
        [border]="false"
        buttonFontSize="16"
        [options]="dayTypeOptions"
        [defaultOption]="selectValue?.dayType || dayTypeOptions[0]"
        (onChange)="setOption({ property: 'dayType', value: $event })"></pdq-dropdown> </span
  ></span>
  <pdq-icon *ngIf="displayDeleteInput" icon="close" (click)="deleteInput()"></pdq-icon>
</span>
